import Skeleton from '@/common/components/skeleton/Skeleton';
import useImageLoader, { normalizeFileId } from '@/common/hooks/useImage';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import ConversationListTrashIcon from './ConversationListTrashIcon';
import {
	AvatarWrap,
	Info,
	HeaderRow,
	HeaderActions,
	Name,
	Timestamp,
	LastMessage,
	ListItem,
	OnlineDot,
	ProfileImage,
	DeleteConversationButton,
} from '../conversationList.styles';

const ConversationListItem = ({
	conversation,
	isActive,
	onClick,
	onDelete,
	isDeleting = false,
	formatTime,
}) => {
	const t = useLanguageData('chat');
	const { imageSrc, isLoading: isImageLoading } = useImageLoader(
		normalizeFileId(conversation.img),
	);
	const time = formatTime(conversation.timestamp);

	const handleDeleteClick = (event) => {
		event.stopPropagation();
		onDelete(conversation.id);
	};

	return (
		<ListItem
			isactive={isActive ? 1 : 0}
			onClick={onClick}
		>
			<AvatarWrap>
				{isImageLoading ? (
					<Skeleton
						width="50px"
						height="50px"
						minWidth="50px"
						minHeight="50px"
						radius="50%"
					/>
				) : (
					<ProfileImage src={imageSrc} alt={conversation.name} />
				)}
				<OnlineDot aria-hidden="true" />
			</AvatarWrap>

			<Info>
				<HeaderRow>
					<Name>{conversation.name}</Name>
					<HeaderActions>
						<DeleteConversationButton
							type="button"
							onClick={handleDeleteClick}
							disabled={isDeleting}
							aria-label={t.deleteConversation}
						>
							<ConversationListTrashIcon />
						</DeleteConversationButton>
						<Timestamp>{time}</Timestamp>
					</HeaderActions>
				</HeaderRow>
				<LastMessage>
					{conversation.lastMessage || '—'}
				</LastMessage>
			</Info>
		</ListItem>
	);
};

export default ConversationListItem;
